export default [
  'employment_type.contractor',
  'employment_type.full_time',
  'employment_type.part_time',
  'employment_type.temporary',
  'employment_type.part_time_mini',
  'employment_type.student',
  'employment_type.training',
];
